<template>
    <div class="flex flex-col gap-4">
        <h3 class="font-light font-heading hidden md:flex items-center gap-2 px-4 py-2 bg-2025-light-beige">
            <FilterIcon class="w-4 h-4 text-grey-darkest" />
            <span>Filter</span>
        </h3>
        <CategoryFilterCollapse
            v-if="category.display_filters"
            title="Personalisation"
        >
            <CategoryFiltering
                :filter-by="filterBy"
                @change:filter-by="$emit('change:filter-by', $event)"
            />
        </CategoryFilterCollapse>
        <CategoryFilterCollapse
            v-if="category.tags.length > 0"
            title="Recipient"
        >
            <CategoryTagSelect
                :tag-id="tagId"
                :options="category.tags"
                @change="$emit('change:tag-id', $event)"
            />
        </CategoryFilterCollapse>
        <CategoryFilterCollapse
            v-if="category.attributes.length > 0"
            title="Colour"
        >
            <CategoryAttributeSelect
                :attribute-id="attributeId"
                :options="category.attributes"
                @change="$emit('change:attribute-id', $event)"
            />
        </CategoryFilterCollapse>
    </div>
</template>

<script>
import CategoryFiltering from '~/components/CategoryFiltering';
import CategoryTagSelect from '~/components/CategoryTagSelect';
import CategoryAttributeSelect from '~/components/CategoryAttributeSelect';
import CategoryFilterCollapse from '~/components/CategoryFilterCollapse';
import FilterIcon from '~/static/fonts/LineIcons/filter.svg';

export default {
    name: 'CategoryFilters',

    components: {
        CategoryFiltering,
        CategoryTagSelect,
        CategoryAttributeSelect,
        CategoryFilterCollapse,
        FilterIcon,
    },

    props: {
        category: {
            type: Object,
            required: true,
        },
        filterBy: {
            type: String,
            required: true,
        },
        tagId: {
            type: [String, Number],
            default: null,
        },
        attributeId: {
            type: [String, Number],
            default: null,
        },
    },
};
</script>
